import { render, staticRenderFns } from "./nav-list.html?vue&type=template&id=4c453c2b&scoped=true&external"
import script from "./nav-list.js?vue&type=script&lang=js&external"
export * from "./nav-list.js?vue&type=script&lang=js&external"
import style0 from "./nav-list.scss?vue&type=style&index=0&id=4c453c2b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c453c2b",
  null
  
)

export default component.exports